export default "__VITE_ASSET__Bbc4avru__";